import { PhArrowUp, PhArrowDown } from '@phosphor-icons/vue'

export const EMAIL_RE = /^[a-zA-Z0-9_+-]+(?:\.[a-zA-Z0-9_+-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/

export const PASSWORD_MIN_LENGTH = 8
export const PASSWORD_MAX_LENGTH = 128
export const PASSWORD_UPPERCASE_RE = /[A-Z]/
export const PASSWORD_LOWERCASE_RE = /[a-z]/
export const PASSWORD_DIGIT_RE = /[0-9]/

export const COLLECTION_NAME_MAX_LENGTH = 50
export const COLLECTION_NAME_DISPLAY_MAX_LENGTH = 35

export const ITEM_LAYOUT_STYLE = {
  cards: 'cards',
  tiles: 'tiles',
  list: 'list',
  headlines: 'headlines',
}

export const BOOKMARK_SORT_FIELDS = {
  createdAt: 'createdAt',
  title: 'title',
  domain: 'sld',
  sld: 'sld', // fix me (collection sorting)
  commentsNumber: 'commentsNumber',
  commentsDate: 'commentsDate',
  likes: 'likes',
}

export const BOOKMARK_SORT_OPTIONS = [
  {
    field: BOOKMARK_SORT_FIELDS.createdAt,
    asc: false,
  },
  {
    field: BOOKMARK_SORT_FIELDS.createdAt,
    asc: true,
  },
  {
    field: BOOKMARK_SORT_FIELDS.title,
    asc: true,
  },
  {
    field: BOOKMARK_SORT_FIELDS.title,
    asc: false,
  },
  {
    field: BOOKMARK_SORT_FIELDS.domain,
    asc: true,
  },
  {
    field: BOOKMARK_SORT_FIELDS.domain,
    asc: false,
  },
  {
    field: BOOKMARK_SORT_FIELDS.commentsNumber,
    asc: false,
  },
  {
    field: BOOKMARK_SORT_FIELDS.commentsNumber,
    asc: true,
  },
  {
    field: BOOKMARK_SORT_FIELDS.commentsDate,
    asc: false,
  },
  {
    field: BOOKMARK_SORT_FIELDS.commentsDate,
    asc: true,
  },
  {
    field: BOOKMARK_SORT_FIELDS.likes,
    asc: false,
  },
  {
    field: BOOKMARK_SORT_FIELDS.likes,
    asc: true,
  },
]

export const BOOKMARK_SORT_OPTIONS_UI = {
  [`${BOOKMARK_SORT_FIELDS.createdAt}-desc`]: {
    string: 'component.bookmarks.sorting.field.createdAt.desc',
    icon: PhArrowDown,
  },
  [`${BOOKMARK_SORT_FIELDS.createdAt}-asc`]: {
    string: 'component.bookmarks.sorting.field.createdAt.asc',
    icon: PhArrowUp,
  },

  [`${BOOKMARK_SORT_FIELDS.title}-asc`]: {
    string: 'component.bookmarks.sorting.field.title.asc',
    icon: PhArrowDown,
  },
  [`${BOOKMARK_SORT_FIELDS.title}-desc`]: {
    string: 'component.bookmarks.sorting.field.title.desc',
    icon: PhArrowUp,
  },

  [`${BOOKMARK_SORT_FIELDS.domain}-desc`]: {
    string: 'component.bookmarks.sorting.field.domain.desc',
    icon: PhArrowUp,
  },
  [`${BOOKMARK_SORT_FIELDS.domain}-asc`]: {
    string: 'component.bookmarks.sorting.field.domain.asc',
    icon: PhArrowDown,
  },

  [`${BOOKMARK_SORT_FIELDS.commentsNumber}-desc`]: {
    string: 'component.bookmarks.sorting.field.commentsNumber.desc',
    icon: PhArrowDown,
  },
  [`${BOOKMARK_SORT_FIELDS.commentsNumber}-asc`]: {
    string: 'component.bookmarks.sorting.field.commentsNumber.asc',
    icon: PhArrowUp,
  },

  // String key swap for comment date is intentional
  [`${BOOKMARK_SORT_FIELDS.commentsDate}-desc`]: {
    string: 'component.bookmarks.sorting.field.commentsDate.asc',
    icon: PhArrowDown,
  },
  [`${BOOKMARK_SORT_FIELDS.commentsDate}-asc`]: {
    string: 'component.bookmarks.sorting.field.commentsDate.desc',
    icon: PhArrowUp,
  },

  [`${BOOKMARK_SORT_FIELDS.likes}-asc`]: {
    string: 'component.bookmarks.sorting.field.likes.asc',
    icon: PhArrowUp,
  },
  [`${BOOKMARK_SORT_FIELDS.likes}-desc`]: {
    string: 'component.bookmarks.sorting.field.likes.desc',
    icon: PhArrowDown,
  },
}

export const COLLECTION_SORT_FIELDS = {
  createdAt: 'createdAt',
  name: 'name',
  newestItem: 'newestItem',
  oldestItem: 'oldestItem',
  title: 'title', // for items view sorting
}

export const COLLECTION_SORT_OPTIONS = [
  {
    field: COLLECTION_SORT_FIELDS.createdAt,
    asc: false,
  },
  {
    field: COLLECTION_SORT_FIELDS.createdAt,
    asc: true,
  },
  {
    field: COLLECTION_SORT_FIELDS.name,
    asc: true,
  },
  {
    field: COLLECTION_SORT_FIELDS.name,
    asc: false,
  },
  {
    field: COLLECTION_SORT_FIELDS.newestItem,
    asc: true,
  },
  {
    field: COLLECTION_SORT_FIELDS.oldestItem,
    asc: true,
  },
]

// Subset for Add to Collections picker (Title A-Z, Title Z-A, Newest, Oldest)
export const ADD_TO_COLLECTION_SORT_OPTIONS = [
  {
    field: COLLECTION_SORT_FIELDS.name,
    asc: true,
  },
  {
    field: COLLECTION_SORT_FIELDS.name,
    asc: false,
  },
  {
    field: COLLECTION_SORT_FIELDS.createdAt,
    asc: false,
  },
  {
    field: COLLECTION_SORT_FIELDS.createdAt,
    asc: true,
  },
]

export const COLLECTION_SORT_OPTIONS_UI = {
  [`${COLLECTION_SORT_FIELDS.createdAt}-desc`]: {
    string: 'component.collections.sorting.field.createdAt.desc',
    icon: PhArrowDown,
  },
  [`${COLLECTION_SORT_FIELDS.createdAt}-asc`]: {
    string: 'component.collections.sorting.field.createdAt.asc',
    icon: PhArrowUp,
  },

  [`${COLLECTION_SORT_FIELDS.name}-asc`]: {
    string: 'component.collections.sorting.field.title.asc',
    icon: PhArrowDown,
  },
  [`${COLLECTION_SORT_FIELDS.name}-desc`]: {
    string: 'component.collections.sorting.field.title.desc',
    icon: PhArrowUp,
  },

  [`${COLLECTION_SORT_FIELDS.newestItem}-asc`]: {
    string: 'component.collections.sorting.field.itemDate.desc',
    icon: PhArrowDown,
  },
  [`${COLLECTION_SORT_FIELDS.oldestItem}-asc`]: {
    string: 'component.collections.sorting.field.itemDate.asc',
    icon: PhArrowUp,
  },
}

export const MAX_READ_TIME = 60

// Post text: author-written intro shown above the item on its detail page.
// Rich text (bold/italic/link + native emoji). Max length is the hard cap; a
// "More"/"Less" toggle appears once the plain-text length passes the threshold.
export const POST_TEXT_MAX_LENGTH = 1000
export const POST_TEXT_MORE_THRESHOLD = 500
export const POST_TEXT_EDITOR_FEATURES = ['bold', 'italic', 'link']

// Comments: shared text limit (mirrors backend COMMENT_TEXT_MAX_LENGTH) and page
// sizes for threaded lists (must be valid backend limit enum values: 5, 10, 25)
export const COMMENT_TEXT_MAX_LENGTH = 1024
export const COMMENTS_PAGE_SIZE = 5
export const REPLIES_PAGE_SIZE = 5
export const COMMENT_LIKES_PAGE_SIZE = 10

// Tag filter match operator: 'any' = match ANY selected tag (OR), 'all' = match ALL (AND)
export const TAG_MATCH = {
  ANY: 'any',
  ALL: 'all',
}

export const DEFAULT_TAG_MATCH = TAG_MATCH.ANY

// Collection Item Resource Types
export const ResourceType = {
  BOOKMARK: 'bookmark',
  NOTE: 'note',
}

// Add-item routes per resource type (used by the bookmark<->note type toggle)
export const ADD_ROUTES = {
  [ResourceType.BOOKMARK]: '/bookmarks/add',
  [ResourceType.NOTE]: '/notes/add',
}

// Query params on the add routes
export const ADD_QUERY = {
  ALLOW_TYPE_CHANGE: 'allowTypeChange', // boolean: show the bookmark<->note toggle
  PREFILL_CONTENT: 'prefillContent', // string: seed note content (e.g. URL carried bookmark->note)
}

// Note Colors
export const NoteColor = {
  YELLOW: 'yellow',
  GREEN: 'green',
  TURQUOISE: 'turquoise',
  PURPLE: 'purple',
  PINK: 'pink',
  RED: 'red',
  ORANGE: 'orange',
  GREY: 'grey',
  BODY: 'body',
}

export const bookmarkFilterDefaults = () => ({
  search: '',
  tags: [],
  isFavorite: false,
  sorting: [BOOKMARK_SORT_FIELDS.createdAt, false],
  readTime: [0, MAX_READ_TIME],
  languages: [],
})

export const collectionBookmarkFilterDefaults = () => ({
  search: '',
  tags: [],
  sorting: [BOOKMARK_SORT_FIELDS.createdAt, false],
  readTime: [0, MAX_READ_TIME],
  languages: [],
})

// Collection Items filter defaults (for v2 API - supports bookmarks and notes)
export const collectionItemFilterDefaults = () => ({
  search: '',
  tags: [],
  tagMatch: DEFAULT_TAG_MATCH,
  resourceType: null, // null = all types, or ResourceType.BOOKMARK / ResourceType.NOTE
  isFavorite: false,
  sorting: [BOOKMARK_SORT_FIELDS.createdAt, false],
  readTime: [0, MAX_READ_TIME],
  languages: [],
})

export const collectionItemsFilterDefaults = () => ({
  search: '',
  tags: [],
  tagMatch: DEFAULT_TAG_MATCH,
  resourceType: null,
  sorting: [BOOKMARK_SORT_FIELDS.createdAt, false],
  readTime: [0, MAX_READ_TIME],
  languages: [],
  addedBy: [],
})

export const collectionsFilterDefaults = () => ({
  search: '',
  sorting: [COLLECTION_SORT_FIELDS.createdAt, false],
})

export const STALE_TIME = 300e3

export const INVITE_LINK_RE = /^\/collections\/([a-f\d]+)\/invite-(link|email)\/([a-z0-9-]+)/i

export const THEME_NAMES = {
  auto: 'page.account.app_settings.theme.auto',
  light: 'page.account.app_settings.theme.light',
  dark: 'page.account.app_settings.theme.dark',
}

export const STYLE_NAMES = {
  [ITEM_LAYOUT_STYLE.cards]: 'page.account.app.layout.cards.title',
  [ITEM_LAYOUT_STYLE.list]: 'page.account.app.layout.lists.title',
  [ITEM_LAYOUT_STYLE.headlines]: 'page.account.app.layout.headlines.title',
  [ITEM_LAYOUT_STYLE.tiles]: 'page.account.app.layout.tiles.title',
}

export const SUB_COLLECTION_POSITION = {
  first: 'first',
  last: 'last',
}

export const SUB_COLLECTION_POSITION_NAMES = {
  [SUB_COLLECTION_POSITION.first]: 'form.field.collection_sub_collection_position.first',
  [SUB_COLLECTION_POSITION.last]: 'form.field.collection_sub_collection_position.last',
}

// Resources that render a "N items" / "3 out of 40 items" line under a page
// title, and the i18n keys backing each. Consumed by PageCountSubtitle.
export const COUNT_SUBTITLE_RESOURCE = {
  items: 'items',
  collections: 'collections',
}

export const COUNT_SUBTITLE_KEYS = {
  [COUNT_SUBTITLE_RESOURCE.items]: {
    total: 'common.items_n',
    filtered: 'common.items_n_filtered',
  },
  [COUNT_SUBTITLE_RESOURCE.collections]: {
    total: 'common.collections_n',
    filtered: 'common.collections_n_filtered',
  },
}

export const MAX_IMPORT_LIMIT = 1000

export const AddToCollectionMethod = {
  MOVE: 'move',
  COPY: 'copy',
}

export const HOW_TO_UPDATE_APP_LINKS = {
  android: {
    en: 'https://rubra.com/help/updating-rubra/android-native-app/',
    de: 'https://rubra.com/de/aktualisierung-von-rubra/aktualisieren-der-nativen-android-app/',
  },
  ios: {
    en: 'https://rubra.com/help/updating-rubra/ios-native-app/',
    de: 'https://rubra.com/de/aktualisierung-von-rubra/aktualisieren-der-nativen-ios-app/',
  },
  firefox: {
    en: 'https://rubra.com/help/updating-rubra/firefox-browser-extension/',
    de: 'https://rubra.com/de/aktualisierung-von-rubra/aktualisierung-der-firefox-browsererweiterung/',
  },
  safari: {
    en: 'https://rubra.com/help/updating-rubra/safari-browser-extension/',
    de: 'https://rubra.com/de/aktualisierung-von-rubra/aktualisieren-der-safari-browsererweiterung/',

  },
  edge: {
    en: 'https://rubra.com/help/updating-rubra/edge-browser-extension/',
    de: 'https://rubra.com/de/aktualisierung-von-rubra/aktualisieren-der-edge-browsererweiterung/',
  },
  chrome: {
    en: 'https://rubra.com/help/updating-rubra/chrome-browser-extension/',
    de: 'https://rubra.com/de/aktualisierung-von-rubra/aktualisieren-der-chrome-browsererweiterung/',
  },
  // Web-App (Should never show as it is updated automatically)
  web: {
    en: 'rubra.com/help/updating-rubra/web-app/',
    de: 'rubra.com/de/aktualisierung-von-rubra/aktualisieren-der-web-app/',
  },
}

export const UPDATE_APP_LINKS = {
  android: 'https://play.google.com/store/apps/details?id=com.rubra.appclient',
  ios: 'https://apps.apple.com/app/rubra-bookmark-manager/id1673761012',
  firefox: 'about:addons',
  safari: 'safari-extension://',
  edge: 'edge://extensions/',
  chrome: 'chrome://extensions/',
}

export const UPDATE_NEWS_LINKS = {
  de: 'https://rubra.com/de/update/',
  en: 'https://rubra.com/update/',
}

export const HELP_LINKS = {
  addBookmark: {
    en: 'https://rubra.com/help/using-rubra/add-items/adding-bookmarks/',
    de: 'https://rubra.com/de/eintrage-hinzufugen/hinzufuegen-von-lesezeichen/',
  },
}

// Custom collections branding (header banner + background). Header image is a
// locked YouTube-banner ratio (1707x282) cropped on upload; on screen it is
// centered and never taller than HEADER_MAX_HEIGHT_PX. Only PNG/JPG accepted.
export const BRANDING = {
  HEADER_ASPECT_RATIO: 1707 / 282,
  HEADER_OUTPUT_SIZE: { width: 1707, height: 282 },
  HEADER_MAX_HEIGHT_PX: 220,
  ALLOWED_IMAGE_MIME: ['image/jpeg', 'image/png'],
  IMAGE_SIZE_LIMIT: 10e6, // 10MB, matches backend config.server.uploads.branding
  DEFAULT_BACKGROUND_COLOR: '#7a1f3d',
}

export const DEFAULT_DURATION = '30d'
export const DEACTIVATION_DURATION = '-1h'

export const MAX_COLLECTIONS_DEEPNESS = 1

// Query param key used by focus-layout pages (edit tags, manage members, etc.)
// to know where to return to after the user finishes the flow.
export const BACK_TARGET_QUERY = 'from'

// Desktop container width (px) for detail pages that show content and comments
// side by side (see DetailColumnsLayout). Wider than the default 720px focus
// width so both columns stay readable.
export const DETAIL_WITH_COMMENTS_MAX_WIDTH = 1080
